'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function (feis, person) {
  var dob = void 0,
      dt_start = void 0;

  if (_immutable.Map.isMap(feis)) {
    dt_start = feis.get('dt_start');
  } else {
    dt_start = feis.dt_start;
  }

  if (_immutable.Map.isMap(person)) {
    dob = person.get('dob');
  } else {
    dob = person.dob;
  }

  if (!dob) {
    return 'n/a';
  }

  var dateParts = dob.match(/^(\d+)\/(\d+)\/(\d+)$/);

  var as_of = new Date(new Date(dt_start).getFullYear() - 1, 11, 31);
  var birthDate = new Date(dateParts[3], parseInt(dateParts[1], 10) - 1, dateParts[2]);
  var age = as_of.getFullYear() - birthDate.getFullYear();

  var m = as_of.getMonth() - birthDate.getMonth();
  if (m < 0 || m === 0 && as_of.getDate() < birthDate.getDate()) {
    age--;
  }

  return age;
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/utilities/getFeisAge/index.js
// module id = 112
// module chunks = 0